<template>
  <div>
    <CContainer class="approval-overtime" v-if="approveInfo">
      <div>
        <!-- <div>
        <h2>{{ $t("label.label_remote_infomation") }}</h2>
      </div> -->
        <ValidationObserver
          tag="form"
          ref="formCreate"
          @submit.prevent="onClickConfirm()"
        >
          <div class="text-label">
            <div class="text-center">
              <h4 class="title-header">
                {{ $t("label.label_remote_infomation") }}
              </h4>
            </div>
          </div>
          <div class="create_form">
            <CRow>
              <CCol md="12" class="form-field">
                <label>
                  {{ $t("employee.label_employee_name") }}
                </label>
                <CInput
                  v-model="approveInfo.employee_name"
                  placeholder="employee name"
                  :disabled="true"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12" class="form-field">
                <label>
                  {{ $t("commons.label_start_date") }}
                </label>
                <CInput v-model="approveInfo.start_date" :disabled="true" />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12" class="form-field">
                <label>
                  {{ $t("commons.label_end_date") }}
                </label>
                <CInput v-model="approveInfo.end_date" :disabled="true" />
              </CCol>
            </CRow>

            <CRow>
              <CCol md="12" class="form-field">
                <label>
                  {{ $t("additional_timeSheet.reason") }}
                </label>
                <CInput v-model="approveInfo.note" :disabled="true" />
              </CCol>
            </CRow>

            <CRow>
              <CCol md="12" class="form-field">
                <label>
                  {{ $t("commons.status") }}
                </label>
                <CInput
                  :value="$t('commons.label_status_' + approveInfo.status)"
                  :disabled="true"
                />
              </CCol>
            </CRow>
            <!-- Overtime approval list-->
            <CRow class="mt-4">
              <CCol md="12" sm="12" class="employees-form approval-ot">
                <div class="text-label">
                  <div class="text-center">
                    <h4 class="title-header">
                      {{ $t("overtime.information_approval_ot") }}
                    </h4>
                  </div>
                </div>
                <div class="text-label-content">
                  <div class="table-responsive table-employee-note">
                    <table class="table">
                      <thead>
                        <tr>
                          <th class="index">#</th>
                          <th class="create-by">
                            {{ $t("overtime.employee_approval") }}
                          </th>
                          <th class="create-at">
                            {{ $t("overtime.employee_approval_status") }}
                          </th>
                          <th>
                            {{ $t("overtime.employee_approval_note") }}
                          </th>
                          <th>
                            {{ $t("overtime.employee_approval_time") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(
                            item, index
                          ) in approveInfo.remote_request_approve"
                          :key="index"
                        >
                          <th scope="row index">{{ index + 1 }}</th>
                          <td>{{ item.approved_by }}</td>
                          <td>
                            {{
                              $t(`overtime.employee_approval_${item.status}`)
                            }}
                          </td>
                          <td class="comment">{{ item.comment }}</td>
                          <td v-if ="item.status != 1">{{ item.updated_at | formatDateTime }}</td>
                          <td v-else></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </CCol>
            </CRow>
            <div v-if="myApproveInfo.status === 1 && approveInfo.status === 1">
              <ValidationObserver ref="form">
                <CRow>
                  <CCol md="12" class="form-field">
                    <label>
                      {{ $t("commons.note") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required|max:255"
                      v-slot="{ errors }"
                      name="overtime.note"
                    >
                      <b-form-textarea
                        rows="3"
                        max-rows="6"
                        v-model="forms.reason"
                      />
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                  <CCol md="12" class="employees-form mt-3 text-center">
                    <CButton
                      type="button"
                      class="save-info"
                      @click="onClickConfirm()"
                    >
                      {{ $t("commons.approve") }}
                    </CButton>
                    <CButton
                      class="cancel-employee"
                      type="button"
                      @click="onClickReject()"
                    >
                      {{ $t("commons.cancel_approve") }}
                    </CButton>
                  </CCol>
                </CRow>
              </ValidationObserver>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </CContainer>
    <CusModal
      @handleCancel="hideApprovalConfirm"
      @handleOk="submitRemoteRequest"
      :title="approveConfirmTitle"
      :isShow="isShowApprovalConfirm"
    >
      <div class="modal-content">
        <div class="warning-title">
          <img src="/img/icons/warning-icon.svg" alt="" />
          {{ $t("popup.commons.label_confirm_title") }}
        </div>
      </div>
    </CusModal>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import moment from "moment";
import CusModal from "@/components/commons/CusModal.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "ApproveRemoteRequestDetail",
  props: ["id"],
  components: {
    // ApprovalAdditionalTimeSheet,
        ValidationObserver,
    ValidationProvider,
    CusModal,
  },
  data() {
    return {
      myApproveInfo: {},
      isShowApprovalConfirm: false,
      forms: {
        id: "",
        status: null,
        reason: "",
      },
      approveConfirmTitle: "",
    };
  },

  computed: {
    ...mapGetters({
      approveInfo: "remote-request/approveInfo",
      flagNotification: "commons/flagNotification",
      account: "auth/account",
    }),
  },

  methods: {
    ...mapActions("remote-request", [
      "approveRemoteRequest",
      "getApprovalRemoteRequestInfo",
    ]),
    ...mapMutations("commons", ["setNotificationFlag"]),

    async showRemoteRequest() {
      await this.getApprovalRemoteRequestInfo(this.id);
      if (this.approveInfo.remote_request_approve) {
        this.myApproveInfo = this.approveInfo.remote_request_approve.filter(
          (f) => f.employee_id === this.account.id
        )[0];
        this.listEmployeeIdApproval = [];
      }
      this.setNotificationFlag(false);
    },

    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
      }
    },
    async onClickConfirm() {
      const isValid = await this.$refs.formCreate.validate();
      if (!isValid) return;
      this.showApprovalConfirm(true);
    },
    async onClickReject() {
      const isValid = await this.$refs.formCreate.validate();
      if (!isValid) return;
      this.showApprovalConfirm(false);
    },

    showApprovalConfirm(approve_status) {
      if (approve_status) {
        this.approveConfirmTitle = "Xác nhận duyệt đơn Remote";
        this.forms.status = 2;
      } else {
        this.approveConfirmTitle = "Xác nhận từ chối đơn Remote";
        this.forms.status = 3;
      }
      this.isShowApprovalConfirm = true;
    },
    submitRemoteRequest() {
      this.$root.$refs.loading.start();
      this.approveRemoteRequest(this.forms)
        .then(() => {
          this.$toast(
            this.$t("popup.label_popup_approve_success"),
            null,
            2000,
            "b-toaster-top-center",
            "success"
          );
          this.showRemoteRequest();
          // this.resetForm();
          this.$store.dispatch('commons/getCountRequest');
          this.$refs.formCreate.reset();
          this.hideApprovalConfirm();
        })
        .finally(() => {
          this.$root.$refs.loading.finish();
        });
    },
    // resetForm() {
    //   this.forms.status = null;
    //   this.forms.reason = "";
    //   this.forms.id = "";
    // },
    hideApprovalConfirm() {
      this.isShowApprovalConfirm = false;
    },
  },

  async created() {
    await this.showRemoteRequest();
    this.forms.id = this.id;
  },

  // watch: {
  //   async flagNotification(value) {
  //     if (value) {
  //       this.listEmployeeIdApproval = [];
  //       await this.showRemoteRequest();
  //     }
  //   }
  // }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 1024px) {
  .mobile-header {
    margin-bottom: 0;
  }
  .approval-overtime {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .row-mobile {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .col-mobile {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .employees-form {
    margin-top: 30px !important;
  }
  .save-info {
    width: 100%;
  }
  .cancel-employee {
    width: 100%;
    margin-top: 5px !important;
  }
  .table {
    width: 550px;
  }
}

.modal-content {
  border: none;

  .warning-title {
    display: flex;
    justify-content: center;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    color: #303c54;
    img {
      margin-right: 10px;
    }
  }
}

.approval-overtime {
  .col-md-10.offset-md-2 {
    margin: auto;
  }

  td.comment {
    max-width: 150px;
    word-wrap: break-word;
  }

  .save-info {
    border-radius: 10px;
    width: 210px;
    height: 40px;
    background-color: #3d4cdc;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    margin-right: 10px;
  }

  label {
    font-weight: 600;
  }

  .input-group {
    margin-bottom: 0px !important;
  }

  .cancel-employee {
    border-radius: 10px;
    width: 210px;
    height: 40px;
    font-weight: 700;
    font-size: 14px;
    background-color: #ececec;
    color: #6f6f6f;
  }

  span.require {
    color: #ff1a1a;
  }

  span.required {
    color: #ff1a1a;
    margin-top: -15px;
  }

  .submit-form {
    margin-top: 30px;
    text-align: center;
  }
}
</style>
